import { AppRoutes, DnsPath, ProductTypes } from '@bn/primitives';
import { GroupedSearchResults } from '@bn/shared/core/api';

export const SearchProductsConfig: GroupedSearchResults = {
  [ProductTypes.CDN]: {
    icon: ['fas', 'location-dot'],
    name: 'PULL ZONE',
    href: AppRoutes.CDN,
  },
  [ProductTypes.DNS]: {
    icon: ['fas', 'sign-hanging'],
    name: 'DNS',
    href: `${AppRoutes.DNS}/${DnsPath.Zones}`,
  },
  [ProductTypes.Stream]: {
    icon: ['fas', 'circle-play'],
    name: 'STREAM',
    href: AppRoutes.Stream,
  },
  [ProductTypes.Script]: {
    icon: ['fas', 'code'],
    name: 'SCRIPT',
    href: AppRoutes.Script,
  },
  [ProductTypes.Storage]: {
    icon: ['fas', 'hard-drive'],
    name: 'STORAGE',
    href: AppRoutes.Storage,
  },
};
